module.exports = __webpack_public_path__ + "static/media/brand-promotion-desktop.c01984dc.jpg";